/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class WorkflowDrawingSettings {
        public width: number;
        public height: number;

        public minZoomPercentage: number;
        public maxZoomPercentage: number;

        public zoomPercentage: number;
        public zoomStep: number;

        public horizontalStep: number;
        public horizontalMin: number;
        public horizontalMax: number;

        public verticalStep: number;
        public verticalMin: number;
        public verticalMax: number;

        public xOrigin: number;
        public yOrigin: number;

        public lineAttributes: any;

        public feedbackLineAttributes: any;
        public feedbackArrowAttributes: any;

        public toggleEnabledfeedbackLineAttributes: any;
        public toggleEnabledfeedbackArrowAttributes: any;

        public dashedLineAttributes: any;
        public arrowAttributes: any;
        
        constructor(width: number, height: number) {
            this.width = width;
            this.height = height;

            this.horizontalStep = 100;
            this.verticalStep = 100; 

            this.minZoomPercentage = 5;
            this.maxZoomPercentage = 175;
            this.zoomStep = 5;

            // Start off at 150% zoom
            this.zoomPercentage = 150;

            this.horizontalMin = 0;
            this.horizontalMax = (this.width - this.horizontalStep) * 3;

            this.verticalMin = 0;
            this.verticalMax = (this.height - this.verticalStep) * 3;

            // Start with offset at 0,0
            this.xOrigin = 0;
            this.yOrigin = 0;

            this.lineAttributes = { class: "arrow" };
            this.dashedLineAttributes = { class: "dashed-arrow"};
            this.arrowAttributes = { class: "arrow-tip" };

            this.feedbackLineAttributes = { class: "feedback-arrow" };
            this.feedbackArrowAttributes = { class: "feedback-arrow-tip" };

            this.toggleEnabledfeedbackLineAttributes = { class: "toggle-enabled-feedback-arrow" };
            this.toggleEnabledfeedbackArrowAttributes = { class: "toggle-enabled-feedback-arrow-tip" };
        }

        public getZoomRatio(): number {
            return this.zoomPercentage / 100;
        }

        private getInverseRatio() {
            var ratio = this.getZoomRatio();
            var distanceFromNormalZoom = Math.abs(1 - ratio);
            return ratio > 1 ? 1 - distanceFromNormalZoom : 1 + distanceFromNormalZoom;
        }

        public getViewBoxWidth(): number {
            var viewBoxRatio = this.getInverseRatio();
            return viewBoxRatio * this.width;
        }

        public getViewBoxHeight(): number {
            var viewBoxRatio = this.getInverseRatio();
            return viewBoxRatio * this.height;
        }

        public getZoomPercentageFromViewBoxWidth(viewBoxWidth: number): number {
            var zoomPercentage = 100 * (2 - (viewBoxWidth / this.width));
            var boundedZoom = Math.min(Math.max(zoomPercentage, this.minZoomPercentage), this.maxZoomPercentage);
            return boundedZoom;
        }

        public getZoomPercentageFromViewBoxHeight(viewBoxHeight: number): number {
            var zoomPercentage = 100 * (2 - (viewBoxHeight / this.height));
            var boundedZoom = Math.min(Math.max(zoomPercentage, this.minZoomPercentage), this.maxZoomPercentage);
            return boundedZoom;
        }
    }
}